// extracted by mini-css-extract-plugin
export default {"activeStatus":"AuditorTable_activeStatus__eeg5M","inactiveStatus":"AuditorTable_inactiveStatus__avXUX","MuiBox-root":"AuditorTable_MuiBox-root__68DIj"};